import React, { Component } from "react";
import { connect } from "react-redux";

class AdminUnitsDetails extends Component {
  handleClick_editUnit = (e) => {
    e.preventDefault();
    this.props.editUnit();
  };

  render() {
    const { unitDetails, showEdit, fetching } = this.props;
    return (
      <React.Fragment>
        {unitDetails ? (
          <h3>{unitDetails.distUnit}</h3>
        ) : fetching ? (
          <h5>Loading...</h5>
        ) : (
          <h5>No unit selected</h5>
        )}
        {unitDetails && <h5 className="text-muted">{unitDetails.description}</h5>}
        {unitDetails && (
          <React.Fragment>
            <div className="row">
              <div className="col pr-1">
                <ul className="list-group-flush pl-0 border-bottom border-top mb-2">
                  <li className="list-group-item py-1 pl-1 pr-0">
                    <div className="row">
                      <div className="col-md-5 pr-1">
                        <b>Unit Mgr:</b>
                      </div>
                      <div className="col-md-7 pl-1">
                        {unitDetails.unitManagerFullName}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1 pr-0">
                    <div className="row">
                      <div className="col-md-5 pr-1">
                        <b>Supervising Unit:</b>
                      </div>
                      <div className="col-md-7 pl-1">
                        {unitDetails.parentUnit
                          ? unitDetails.parentUnit.distUnit
                          : "(N/A)"}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1 pr-0">
                    <div className="row">
                      <div className="col-md-5 pr-1">
                        <b>Child Units:</b>
                      </div>
                      <div className="col-md-7 pl-1">
                        {unitDetails.childUnits && unitDetails.childUnits.length > 0
                          ? unitDetails.childUnits.map((cu) => cu.distUnit).join(", ")
                          : "(N/A)"}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1 pr-0">
                    <div className="row">
                      <div className="col-md-5 pr-1">
                        <b>Unit Staff:</b>
                      </div>
                      <div className="col-md-7 pl-1">
                        {unitDetails.unitStaff && unitDetails.unitStaff.length > 0
                          ? unitDetails.unitStaff.map((us) => (
                              <div
                                className="list-group-item py-0 pl-1"
                                key={`unitStaffKey_${us.userId}`}
                              >
                                {`${us.fullName}, ${us.userRoleSymbol}`}
                              </div>
                            ))
                          : "(None)"}
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item py-1 pl-1 pr-0">
                    <div className="row">
                      <div className="col-md-5 pr-1">
                        <b>Unit Projects:</b>
                      </div>
                      <div className="col-md-7 pl-1">
                        {unitDetails.unitProjects && unitDetails.unitProjects.length > 0
                          ? unitDetails.unitProjects.map((up) => (
                              <div
                                className="list-group-item py-0 pl-1"
                                key={`unitProjKey_${up.projectId}`}
                              >
                                {`${up.fullEA}, ${up.coRtePm}`}
                              </div>
                            ))
                          : "(None)"}
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {showEdit && (
              <button
                type="button"
                name="editUnit"
                id="editUnit"
                className="btn btn-sm btn-secondary"
                onClick={this.handleClick_editUnit}
              >
                Edit Unit...
              </button>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  fetching: state.users.fetching,
  unitDetails: state.users.openUnitDetails[ownProps.unitId] || null,
});

export default connect(mapStateToProps)(AdminUnitsDetails);
